import moment from 'moment'
import snakecaseKeys from 'snakecase-keys'
import Repository from '@/repositories/Repository'
import News from '@/models/News'
import NewsItem from '@/models/NewsItem'
import { rangeToISO } from '@/lib/formatter'

class NewsRepository extends Repository {
  constructor() {
    super('/news')
  }

  async fetch(notificationId: string) {
    const params = { notificationId, camelcaseKeys: true }
    const attributes = await super._post(params, 'current')

    return new News(attributes)
  }

  async history(notificationId: string, date: Date) {
    const current = moment(date)
    const range = {
      startTime: current.startOf('month').format(),
      endTime: current.endOf('month').format(),
    }
    const formatRange = snakecaseKeys(rangeToISO(range as Range))
    const params = { notificationId, range: formatRange, camelcaseKeys: true }
    const attributes = await super._post(params, 'history')

    return new News(attributes)
  }

  async createOrUpdate(notificationId: string, newsItem: NewsItem) {
    const item = newsItem.toParams()

    if (item.id === undefined) {
      delete item.id
    }

    const params = { notificationId, item, camelcaseKeys: true }
    const response = await super._post(params, 'edit')
    const newItem = response.items[0]

    return new NewsItem(newItem)
  }

  async delete(notificationId: string, id: number) {
    const params = { notificationId, item: { id }, camelcaseKeys: true }
    const response = await super._post(params, 'delete')
    const newItem = response.items[0]

    return new NewsItem(newItem)
  }
}

export default NewsRepository
